import { render } from "./WCStoreLabelSmall.vue?vue&type=template&id=11cdf3e6&ts=true"
import script from "./WCStoreLabelSmall.vue?vue&type=script&lang=ts"
export * from "./WCStoreLabelSmall.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__